export default __webpack_public_path__ + "static/media/Image3.61f6c0fb.png";